<template>
	<div>
		<div class='flex'
			:class='[
				dark ? "text-grey-400" : "text-grey-900",
				disabled && dark ? "!text-grey-900" : ""
			]'
		>
			<div class='shrink-0'
				:class='[ 
					time ? "w-[70%]" : "w-full",
				]'
			>
				<p class='text-14  pb-1' v-if='label != null'>{{ label }} date</p>
			</div>

			<div class='w-[30%] shrink-0 pl-4 hidden lg:block' v-if='time'>
				<p class='text-14 pb-1' v-if='label != null'>{{ label }} time</p>
			</div>
		</div>

		<div class='lg:flex'>
			<div class='flex shrink-0' v-if='date'
				:class='[ time ? "lg:w-[70%]" : "w-full" ]'
			>
				<Select class='w-fit shrink-0'
					boxClass='border-r-0'
					placeholder='Day'
					:options='days'
					:value='lValue.format("D")'
					@update:value='setDay'
					:dark='dark'
					:disabled='disabled'
				/>

				<Select class='w-full'
					boxClass='border-r-0'
					placeholder='Month'
					:options='monthNames.map(mn => {
						return { value: mn }
					})'
					:value='lValue.format("MMMM")'
					@update:value='setMonth'
					:dark='dark'
					:disabled='disabled'
				/>

				<Select class='w-fit shrink-0'
					placeholder='Year'
					:options='years'
					:value='lValue.format("YYYY")'
					@update:value='setYear'
					:dark='dark'
					:disabled='disabled'
				/>
			</div>

			<p class='text-14 text-grey-900 pb-1 pt-4 lg:hidden' v-if='time && label != null'>{{ label }} time</p>

			<div class='flex shrink-0' v-if='time'
				:class='{
					"w-full": !date,
					"lg:w-[30%] w-[50%] lg:pl-4": date
				}'
			>
				<Select class='w-full'
					boxClass='border-r-0'
					placeholder='Hour'
					:options='hours'
					:value='lValue.format("HH")'
					@update:value='setHour'
					:dark='dark'
					:disabled='disabled'
				/>

				<Select class='w-full'
					placeholder='minute'
					:options='minutes'
					:value='lValue.format("mm")'
					@update:value='setMinute'
					:dark='dark'
					:disabled='disabled'
				/>
			</div>
		</div>

		<Error :name='name' :error='error' />

		<input type='hidden' :value='lValue.format("YYYY-MM-DD HH:mm")' :name='name' v-if='hasInput' />
	</div>
</template>

<script>
	export default {
		props: {
			label: String,
			value: [String, Object],
			name: String,
			time: { type: Boolean, default: true },
			date: { type: Boolean, default: true },
			dark: { type: Boolean, default: false },
			disabled: { type: Boolean, default: false },
			hasInput: { type: Boolean, default: true },
		},

		emits: ['update:value'],

		data() {
			return {
				monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
				lValue: this.$moment(this.value)
			}
		},

		methods: {
			setDay(day) {
				this.lValue = this.$moment(this.lValue).date(day)
				this.$emit('update:value', this.lValue)
			},

			setMonth(month) {
				this.lValue = this.$moment(this.lValue).month(month)
				this.$emit('update:value', this.lValue)
			},

			setYear(year) {
				this.lValue = this.$moment(this.lValue).year(year)
				this.$emit('update:value', this.lValue)
			},

			setHour(hour) {
				this.lValue = this.$moment(this.lValue).hour(hour)
				this.$emit('update:value', this.lValue)
			},

			setMinute(minute) {
				this.lValue = this.$moment(this.lValue).minute(minute)
				this.$emit('update:value', this.lValue)
			}
		},

		computed: {
			days() {
				let d = [];

				for (let b = 1; b <= this.lValue.daysInMonth(); b++) {
					d.push({value: b})
				}

				return d
			},

			years() {
				let y = []

				for (let i = 2020; i < parseInt(this.$moment().format('YYYY')) + 5; i++) {
					y.push({
						value: i
					})
				}

				return y
			},

			hours() {
				let h = [];

				for (let i = 0; i < 24; i++) {
					h.push({ value: i < 10 ? '0'+String(i) : i })
				}

				return h
			},

			minutes() {
				let h = [];

				for (let i = 0; i < 60; i++) {
					h.push({ value: i < 10 ? '0'+String(i) : i })
				}

				return h
			},

			error() {
				let inputForm = this.$help.getComponent(this, 'InputForm');

				return inputForm != null
					? inputForm.$data.errors.has(this.errorKey != null ? this.errorKey : this.name)
					: false;
			},
		},
	}
</script>